import { SBCRewardType } from "@/api/privateRequests/sbcs/getSbcSets";
import { Tier } from "@/redux/players/playersSlice";
import { BREAKPOINTS } from "@/settings";
import clsx from "clsx";
import { useMediaQuery } from "usehooks-ts";

import { SBCRewardDescription } from "../SBCRewardDescription/SBCRewardDescription";

type Props = {
  reward: SBCRewardType;
  rewardUrl: string;
  playerRole?: string;
  description?: string;
  tier?: Tier;
};

export const SBCReward = ({
  reward,
  rewardUrl,
  playerRole,
  description,
  tier,
}: Props) => {
  const isMobile = useMediaQuery(BREAKPOINTS.MOBILE.query);

  return isMobile ? (
    <div className={clsx("h-full w-full flex gap-2")}>
      <img
        loading="lazy"
        className={clsx(
          "h-24 w-auto",
          reward?.type === "player" && "max-w-none h-32 -mt-4 -mb-4",
        )}
        alt={reward?.name}
        src={rewardUrl}
      />

      <div className="flex flex-col justify-between h-full w-full">
        <SBCRewardDescription
          rewardType={reward?.type}
          description={reward?.description || description}
          playerRole={playerRole}
          rewardName={reward?.name || reward?.shortName}
          rewardMetaRating={reward?.metaRating?.metarating}
          untradeable={reward?.untradeable}
          tier={tier}
        />
      </div>
    </div>
  ) : (
    <div
      className={clsx(
        "h-full w-full flex flex-row gap-x-2 py-5 rounded-lg",
        reward?.type === "pack"
          ? "px-2 desktop:px-3 pb-4"
          : reward?.type === "player"
            ? "desktop:px-2 py-1"
            : ["playerpick", "cosmetic-evo"].includes(reward?.type)
              ? "pl-1"
              : "desktop:px-2",
      )}
    >
      <img
        loading="lazy"
        className={clsx(
          "mb-auto",
          reward?.type === "player"
            ? "h-[125px] desktop:h-[110px]"
            : reward?.type === "item"
              ? "w-16 -mt-3 ml-1 md-lg:ml-2"
              : ["playerpick", "cosmetic-evo"].includes(reward?.type)
                ? "w-16 md-lg:w-20 md-lg:pl-2 -mt-3"
                : " w-16 pl-2",
        )}
        alt={reward?.name}
        src={rewardUrl}
      />
      <div
        className={clsx(
          "flex flex-col justify-between h-full mb-auto",
          reward?.type === "player"
            ? "pt-1"
            : !["playerpick", "cosmetic-evo"].includes(reward?.type) &&
                "desktop:pl-2",
        )}
      >
        <SBCRewardDescription
          rewardType={reward?.type}
          description={reward?.description || description}
          playerRole={playerRole}
          rewardName={reward?.name || reward?.shortName}
          rewardMetaRating={reward?.metaRating?.metarating}
          untradeable={reward?.untradeable}
          tier={tier}
        />
      </div>
    </div>
  );
};
